import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEOHead from "@/components/site/SEOHead";

export default function NotFound() {
  return (
    <div className="container-x pt-40 pb-32 text-center" data-testid="not-found-page">
      <SEOHead title="Page not found — Happy Retreats" description="The page you're looking for doesn't exist." noindex />
      <div className="overline">404</div>
      <h1 className="display-2 mt-4">Page not found</h1>
      <p className="text-graphite mt-6 max-w-md mx-auto">The page you're looking for may have moved or never existed.</p>
      <Link to="/" className="link-arrow mt-8 inline-flex" data-testid="not-found-home-link">Back to home <ArrowRight className="w-4 h-4" /></Link>
    </div>
  );
}
